import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import TestAndScore from "../../../components/Faculty/TestAndScore";

const TestAndScorePage = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <TestAndScore />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default TestAndScorePage;
